import React, {Component} from "react";
import SimpleInput from "../../../../modules/SimpleInput";
import {ACTIVITY_TYPE} from "../../../common/Constants";
import SimpleDate from "../../../../modules/SimpleDate";
import {kategoriNotifikasiOptions} from "../config";
import SimpleDDL from "../../../../modules/SimpleDDL";
import * as R from "ramda";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import SimpleTextEditor from "../../../../modules/SimpleTextEditor";
import SimpleUploadImage from "../../../../modules/upload/SimpleUploadImage";
import FlexView from "react-flexview";

class NotificationModifyingHeader extends Component {
    render() {
        return (
            <FlexView column>
                <div className="grid grid-2x gap-20px">
                    <div id="grid-1">
                        <SimpleInput
                            name="idNotifikasi"
                            label="ID Notifikasi"
                            value={this.props.controls.idNotifikasi?.value || null}
                            readOnly
                        />
                    </div>
                    <div id="grid-2">
                        <SimpleDate
                            name="tanggalNotifikasiDikirim"
                            label="Tanggal Notifikasi Dikirim"
                            value={this.props.controls.tanggalNotifikasiDikirim?.value || null}
                            disabled
                        />
                    </div>
                </div>
                <SimpleDDL
                    box="search"
                    id="select_options_notification_category"
                    name="kategoriNotifikasi"
                    label="Kategori Notifikasi"
                    mandatory={this.props.activityType !== ACTIVITY_TYPE.VIEW}
                    errorMessage={this.props.errors.kategoriNotifikasi}
                    value={this.props.controls.kategoriNotifikasi?.value || null}
                    options={this.props.categoryOptions}
                    onChange={(value, {name}) => this.props.setValue(name, value)}
                    readOnly={this.props.activityType === ACTIVITY_TYPE.VIEW}
                />
                <SimpleInput
                    name="judulNotifikasi"
                    label="Judul Notifikasi"
                    mandatory={this.props.activityType !== ACTIVITY_TYPE.VIEW}
                    errorMessage={this.props.errors.judulNotifikasi}
                    value={this.props.controls.judulNotifikasi?.value || null}
                    readOnly={this.props.activityType === ACTIVITY_TYPE.VIEW}
                    onChange={({target}) => this.props.setValue(target.name, target.value)}
                />
                <SimpleInput
                    name="judulMessage"
                    label="Judul Message"
                    value={this.props.controls.judulMessage?.value || null}
                    readOnly={this.props.activityType === ACTIVITY_TYPE.VIEW}
                    onChange={({target}) => this.props.setValue(target.name, target.value)}
                />
                <SimpleTextEditor
                    name="isiNotifikasi"
                    label="Isi Notifikasi"
                    mandatory={this.props.activityType !== ACTIVITY_TYPE.VIEW}
                    errorMessage={this.props.errors.isiNotifikasi}
                    value={this.props.controls.isiNotifikasi?.value || null}
                    readOnly={this.props.activityType === ACTIVITY_TYPE.VIEW}
                    onChange={value=>{
                        this.props.setValue("isiNotifikasi", value)
                    }}
                />
                {this.props.tab === "customer" && (
                    <FlexView>
                        <SimpleUploadImage
                            category={this.props.activityType === ACTIVITY_TYPE.VIEW ? "" : "upload"}
                            id="input_upload_notification_picture"
                            name="gambarNotifikasiBase64"
                            label="Gambar"
                            value={this.props.controls.gambarNotifikasiBase64?.value || null}
                            onChange={(value, name) => this.props.setValue(name, value)}
                        />
                    </FlexView>
                )}
            </FlexView>
        )
    }
}

export default NotificationModifyingHeader;